export default __webpack_public_path__ + "static/media/saintlymartyr.dcab5a73.png";